import React, { useState, useEffect } from 'react';
import './BrandPriceManager.css';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const BrandPriceManager = () => {
  const [brands, setBrands] = useState([]);
  const [loadingBrands, setLoadingBrands] = useState(true);

  const [form, setForm] = useState({
    BrandId: '',
    type: 'percentage',
    operation: 'increase',
    value: '',
    brandId: ''
  });

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  // load brands
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const token = localStorage.getItem('token');

        const res = await fetch(`${API}/brands`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        const data = await res.json();

        if (data.success) {
          setBrands(data.data);
        }
      } catch (err) {
        console.error('Error loading brands:', err);
      } finally {
        setLoadingBrands(false);
      }
    };

    fetchBrands();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.brandId || !form.value) {
      alert('Brand and value are required');
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      const token = localStorage.getItem('token');

      const res = await fetch(
        `${API}/products/vendor/${form.brandId}/update-prices`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            type: form.type,
            operation: form.operation,
            value: parseFloat(form.value)
          })
        }
      );

      const data = await res.json();

      setResult({
        success: data.success,
        message: data.message || data.error
      });
    } catch (err) {
      setResult({
        success: false,
        message: 'Server error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Brand-price-page">
      <div className="Brand-price-header">
        <h2>Price Update</h2>
        <p className="Brand-subtitle">
          Bulk update product variant prices by brand
        </p>
      </div>

      <div className="Brand-price-card">
        <form onSubmit={handleSubmit} className="Brand-form">

          {/* BRAND DROPDOWN */}
          <div className="form-field">
            <label>Brand</label>

            <select
              value={form.brandId}
              onChange={(e) =>
                setForm({ ...form, brandId: e.target.value })
              }
              disabled={loadingBrands}
            >
              <option value="">
                {loadingBrands
                  ? 'Loading brands...'
                  : 'Select brand'}
              </option>

              {brands.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-row-2">
            <div className="form-field">
              <label>Type</label>
              <select
                value={form.type}
                onChange={(e) =>
                  setForm({ ...form, type: e.target.value })
                }
              >
                <option value="percentage">Percentage (%)</option>
                <option value="fixed">Fixed Amount ($)</option>
              </select>
            </div>

            <div className="form-field">
              <label>Operation</label>
              <select
                value={form.operation}
                onChange={(e) =>
                  setForm({ ...form, operation: e.target.value })
                }
              >
                <option value="increase">Increase (+)</option>
                <option value="decrease">Decrease (-)</option>
              </select>
            </div>
          </div>

          <div className="form-field">
            <label>
              Value {form.type === 'percentage' ? '(%)' : '($)'}
            </label>

            <input
              type="number"
              step="0.01"
              value={form.value}
              onChange={(e) =>
                setForm({ ...form, value: e.target.value })
              }
              placeholder="e.g. 10"
            />
          </div>

          <button
            className="btn-update-price"
            disabled={loading}
          >
            {loading ? 'Updating...' : 'Update Prices'}
          </button>
        </form>

        {result && (
          <div
            className={`result-box ${
              result.success ? 'success' : 'error'
            }`}
          >
            {result.message}
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandPriceManager;